module.exports = __webpack_public_path__ + "img/04.871f31a9.png";